import { render } from "./ScoutTab.vue?vue&type=template&id=79faf61d&scoped=true"
import script from "./ScoutTab.vue?vue&type=script&lang=js"
export * from "./ScoutTab.vue?vue&type=script&lang=js"

import "./ScoutTab.vue?vue&type=style&index=0&id=79faf61d&scoped=true&lang=scss"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79faf61d"]])

export default __exports__